import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { getTable } from '../../api/api';
import { formatDate } from '../../utils/helpers';

const NewsCard = ({ item }) => (
  <Link to={`/actualite/${item.slug}`} className="card">
    <div className="card-media">
      <img src={item.image_url} alt={item.title} loading="lazy" />
    </div>
    <div className="card-body">
      <span className="tag">{item.category}</span>
      <h3>{item.title}</h3>
      <p className="excerpt">{(item.excerpt || '').slice(0, 110)}...</p>
      <div className="card-meta">
        <span>{formatDate(item.publish_date)}</span>
      </div>
    </div>
  </Link>
);

const NewsSection = () => {
  const [news, setNews] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        // ✅ Correction: sort au lieu de 'sort=-publish_date'
        const res = await getTable('tables/news', { limit: 3, sort: '-publish_date' });
        setNews(res.data || []);
      } catch (e) {
        console.error('Erreur chargement actualités:', e);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  if (loading) {
    return (
      <section className="section">
        <div className="container">
          <div className="section-head">
            <div>
              <span className="section-kicker">Actualités</span>
              <h2 className="section-title">Vie de l'institut &amp; actualité économique</h2>
            </div>
          </div>
          <div className="grid grid-3">
            {[1, 2, 3].map((i) => (
              <div key={i} className="card" style={{ opacity: 0.6 }}>
                <div className="card-media" style={{ background: '#e1e5eb' }} />
                <div className="card-body">
                  <h3>Chargement...</h3>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    );
  }

  return (
    <section className="section">
      <div className="container">
        <div className="section-head">
          <div>
            <span className="section-kicker">Actualités</span>
            <h2 className="section-title">Vie de l'institut &amp; actualité économique</h2>
          </div>
          <Link to="/actualites" className="btn btn-ghost">
            Toutes les actualités <i className="fa-solid fa-arrow-right"></i>
          </Link>
        </div>

        <div className="grid grid-3">
          {news.map((item) => (
            <NewsCard key={item.id} item={item} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default NewsSection;